// src/rms/utils/postcode.js

export function normalizeUkPostcode(raw) {
  if (!raw) return '';
  const trimmed = String(raw).trim().toUpperCase();
  // Insert single space before last 3 characters if missing
  const compact = trimmed.replace(/\s+/g, '');
  if (compact.length > 3) {
    return `${compact.slice(0, compact.length - 3)} ${compact.slice(-3)}`;
  }
  return trimmed;
}

export function isLikelyUkPostcode(raw) {
  if (!raw) return false;
  const s = normalizeUkPostcode(raw);
  const re = /^[A-Z]{1,2}\d[\dA-Z]? ?\d[A-Z]{2}$/i;
  return re.test(s);
}


